module.exports = __webpack_public_path__ + "img/ct-zh_CN-img.ca8a22d6.png";